import questionTypes from "../data/constants/questionTypes";
export const getHintText = (type, maxQuestions) => {
    switch (type) {
        case questionTypes.radio:
            return "Please select one";
        case questionTypes.checkbox:
            if (maxQuestions !== null) {
                return `Select your top ${maxQuestions}`;
            }
            return "Select all that apply";
        case questionTypes.combinedHeight:
            return "Goal weight";
        default:
            return null;
    }
};
export const getIsInterstitial = (questionType) => ["rd_interstitial", "interstitial", "target_interstitial", "results_animation", "target_animation", "video"].includes(questionType);
export const getHideBottomBar = (questionType) => ["rd_interstitial", "results_animation", "target_animation", "target_interstitial"].includes(questionType);
